import { Link } from 'react-router-dom';
import { categories } from '@/mocks/games';

interface GameCardProps {
  id: number;
  title: string;
  category: string;
  image: string;
  description: string;
  rating: number;
  downloads: number;
  date: string;
  slug: string;
  fileSize: string;
  platform: string;
}

export default function GameCard({
  title,
  category,
  image,
  description,
  rating,
  downloads,
  slug,
  fileSize,
  platform,
}: GameCardProps) {
  const categoryInfo = categories.find((c) => c.slug === category);

  const formatDownloads = (num: number) => {
    if (num >= 10000) {
      return `${(num / 10000).toFixed(1)}万`;
    }
    return num.toString();
  };

  return (
    <Link
      to={`/article/${slug}`}
      className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
      data-product-shop
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={image}
          alt={title}
          title={`${title} - 黄游免费下载`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-background-50/90 text-foreground-700 backdrop-blur-sm">
            {platform}
          </span>
        </div>
        {categoryInfo && (
          <div className="absolute top-3 right-3">
            <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500/90 text-background-50 backdrop-blur-sm">
              {categoryInfo.name}
            </span>
          </div>
        )}
      </div>

      <div className="p-4">
        <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2 mb-3">
          {description}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-amber-400 text-xs"></i>
              {rating}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-download-line text-xs"></i>
              {formatDownloads(downloads)}
            </span>
          </div>
          <span className="text-foreground-300">{fileSize}</span>
        </div>
      </div>
    </Link>
  );
}